import { render, staticRenderFns } from "./facialkeypoint.vue?vue&type=template&id=7d67a648&scoped=true&"
import script from "./facialkeypoint.vue?vue&type=script&lang=js&"
export * from "./facialkeypoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d67a648",
  null
  
)

export default component.exports